var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"div",staticClass:"hover",class:_vm.classes,on:{"click":_vm.toggle}},[_c('div',{staticClass:"hover__default"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"hover__hover"},[_vm._t("hover")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }